/*
 * ॐ नमः शिवाय
 *
 * Copyright (c) 2025 Rudra Coresoft Technologies Private Limited
 *
 * This software is licensed under the VIJAYA 1.0 License.
 *
 * MANDATORY ATTRIBUTION:
 * 1. The attribution to Rudra Coresoft Technologies Private Limited in this
 *    copyright notice must not be removed even after modifications.
 * 2. For Free License usage, the footer phrases "Powered by arcee.io" and
 *    "Developed by Rudra Coresoft" (plus logos) must remain visible.
 *
 * See the LICENSE file for the full text.
 */

/**
 * Builds the `loadChildEdges(tableName)` the Related Data panel uses to offer a
 * ticked table's own related tables.
 *
 * The related-edges endpoint is addressed by table id, while a stored source
 * names its table — the same name-within-this-application lookup the server
 * does itself. `tables` is this application's table list, which the config
 * page already loads; `fetchEdges(id)` returns that endpoint's JSON and throws
 * when the request fails, so a failure reaches the panel as a failure rather
 * than as "no related tables".
 */
export function makeChildEdgesLoader(tables, fetchEdges) {
  const idByName = new Map((tables || []).map(t => [t.name, t.id]));

  return async function loadChildEdges(tableName) {
    const id = idByName.get(tableName);
    if (id === undefined || id === null) return [];
    const data = await fetchEdges(id);
    return Array.isArray(data?.edges) ? data.edges : [];
  };
}
